export default __webpack_public_path__ + "static/media/Goremonger's Helm.7db4ef01.jpg";